/**
 * Load More Model
 * This model defines data structure for the Load More view that can be used
 * for the Dust template to render on both server-side and client-side
 */
import Backbone from 'backbone';

export default Backbone.Model.extend({
	defaults: {
		showLoadMore: false,
		nextPageToken: ''
	},

	setLoadMore (options) {
		// allow undefined to be passed (triggers false state)
		options = options || {};

		if (options.show) {
			this.set('showLoadMore', true);

			// Throw an error here if there's a problem
			// helps make it obvious what needs to be fixed
			if (!options.nextPageToken) {
				throw new Error('nextPageToken is required');
			}

			this.set('nextPageToken', options.nextPageToken);
		} else {
			this.set('showLoadMore', false);
		}
	}
});



// WEBPACK FOOTER //
// ./model/activity/loadMoreModel.es6